module.exports = __webpack_public_path__ + "img/addon-custom-aic.ee03b12b.png";